module.exports = __webpack_public_path__ + "static/media/autosport.de921ca7.jpg";